module.exports = __webpack_public_path__ + "img/arcadeplate.c6899063.jpg";